import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom"; // Import Link


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Pages */}
        <div className="footer-section">
          <h3>Main Pages</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/objectives">Our Objectives</Link></li>
            <li><Link to="/activities">Our Activities</Link></li>
            <li><Link to="/WorkPrograms">Work Programs</Link></li>
          </ul>
        </div>

        {/* Additional Pages */}
        {/* <div className="footer-section">
          <h3>Additional Pages</h3>
          <ul>
            <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
            
          </ul>
        </div> */}

        {/* Social Media Links 
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            
            <a href="https://www.linkedin.com/company/ogits-sa" target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
            
          </div>
        </div>  */}

        {/* Contact Information */}
        <div className="footer-section">
          <h3>Contact us</h3>
          <p>Kingdom of Saudi Arabia, Riyadh</p>
          {/* <p>Tel: +966555509565</p> */}
          <p>Email: <a href="mailto:info@ogits.net">info@ogits.net</a></p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>Copyright © Open Global Information Technology Solutions (OGITS). All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
